<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import AdminForm from '@/components/admin/AdminForm.vue'
import AdminMesureUniteForm from '@/components/admin/mesureUnite/AdminMesureUniteForm.vue'
import { AloDbMesureUnite } from '@/models/alodb/AloDbMesureUnite'
import { SecurityItemsKeys } from '@/enum/SecurityItems'


@Component({
  name: 'AdminMesureUnite',
  components: {AdminMesureUniteForm}
})
export default class AdminMesureUnite extends AdminForm<AloDbMesureUnite> {  
  get itemTypeName() {
    return "MesureUnite"
  }

  created() {                            
    if(!this.$store.myGetters.userSecurity[SecurityItemsKeys.ADMIN_MESUREUNIT].enable) {
      this.canRender = false       
      this.$router.push('/')
    }     
  }

}
</script>